export const USER_ROLE = {
    DOCTOR: "ROLE_DOCTOR",
    SYSTEM_ADMIN : "ROLE_SYS_ADMIN",//ROLE_SYSTEM_ADMIN
    HCP_ADMIN : "ROLE_HCP_ADMIN",
    PATIENT : "ROLE_PATIENT"
};
